import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import ModalBox, { ModalBody, ModalHeader } from "./ModalBox";
import Button from "../Button";
import { sendOtp, verifyOtp } from "../../services/customer/auth";
import Loader from "../Loader";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { updateUserInfo } from "../../redux/slices/authSlice";
import useCountdown from "../../hooks/useCountdown";
import { getAuth } from "firebase/auth";
import { app } from "../../firebase";

interface IProps {
  showModal: boolean;
  closeModal: () => void;
  handleChange?: CallableFunction;
  contactNumber: string;
}

const OtpModal: React.FC<IProps> = ({
  showModal,
  closeModal,
  handleChange,
  contactNumber,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [code, setCode] = useState("");

  const auth = getAuth(app);

  const onChange = (code: string) => {
    setCode(code);
    handleChange && handleChange(code);
  };

  const handleDisabled = (value: boolean) => setIsDisabled(value);

  const handleCountdownEnd = () => {
    handleDisabled(false); // Enable the button when countdown ends
  };

  const { countdown, resetCountdown } = useCountdown({
    initialCount: 60,
    onCountdownEnd: handleCountdownEnd,
  });

  const handleStartCountdown = () => {
    resetCountdown(60); // Reset the countdown to 30 when the button is clicked
  };

  const handleUserData = (data: any) => {
    const userData = {
      userInfo: data?.user,
      accessToken: data?.token,
      loading: false,
    };
    dispatch(updateUserInfo(userData));
  };

  const handleVerify = () => {
    const confirmationResult = (window as Window | any)?.confirmationResult;
    if (contactNumber) {
      setLoading(true);
      verifyOtp(
        confirmationResult,
        code,
        (value: boolean) => setLoading(value),
        handleUserData
      );
    }
  };

  const handleResendOtp = () => {
    const appVerifier = (window as Window | any).recaptchaVerifier;
    sendOtp(appVerifier, auth, contactNumber, (confirmation: any) => {
      if (confirmation) {
        (window as Window | any).confirmationResult = confirmation;
      }
      handleStartCountdown();
    });
  };

  const [columns, setColumns] = useState(6);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 550) {
        setColumns(3); // For tablets
      } else {
        setColumns(6); // Default
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call once to set initial value

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <ModalBox
        show={showModal}
        closeModal={closeModal}
        boxSize="max-w-xl"
        className="request-tour-model"
      >
        <ModalHeader>
          <div className="py-4 border-b border-black">
            <h3 className="font-bold text-base md:text-xl text-center">
              Enter OTP recieved on phone
            </h3>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="p-4">
            <div className="space-y-6 md:px-8 md:pt-4 pb-6">
              <h3 className="font-semibold text-base md:text-2xl text-center">
                Please enter OTP recieved on{" "}
                <div>+91 ******{contactNumber?.slice(9)}</div>
              </h3>
              <div className="text-base text-center">
                After you recieve OTP it is valid for 5 Min
              </div>
              <div className="flex flex-col gap-8">
                <OtpInput
                  value={code}
                  onChange={onChange}
                  numInputs={6}
                  renderInput={(props) => <input {...props} />}
                  shouldAutoFocus={true}
                  inputStyle={{
                    border: "1px solid black",
                    borderRadius: "8px",
                    width: "54px",
                    height: "54px",
                    fontSize: "12px",
                    color: "#000",
                    fontWeight: "400",
                    caretColor: "blue",
                    // marginRight: "8px",
                  }}
                  containerStyle={{
                    // flexWrap: "wrap",
                    // justifyContent: "center",
                    gap: 20,
                    display: "grid",
                    gridTemplateColumns: `repeat(${columns}, 1fr)`,
                    justifyItems: "center",
                  }}
                />
                <Button
                  onClick={handleVerify}
                  disabled={loading || code?.length < 6}
                >
                  {loading ? <Loader size="small" /> : "Verify"}
                </Button>
                <div className="-mt-3 text-center md:text-right">
                  <button
                    disabled={isDisabled || !!countdown}
                    onClick={handleResendOtp}
                    className="text-dark-cyan"
                  >
                    Resend OTP
                  </button>
                  {countdown > 0 && (
                    <div className="text-sm">
                      <span>You can resend OTP in </span>
                      <span className="sec">{countdown} sec</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalBox>
    </div>
  );
};

export default OtpModal;
